var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[_c('textarea',{ref:"input",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"required":_vm.required},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }